import React from "react";
import { Button } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailModel";
import { Description } from "@/erp_subpackage/components/YhBox/Description";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";

export const TopButs = ({ modeKey, mode, rowCode, dispatch }) => {
    const { editFormVal, addFormVal, lookFormVal, setSettleVisible, setWsConfirmVisible, controlled, verifyWhOrShelf } = usePurchaseRoDetailsModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const formVal = mode === "edit" ? editFormVal : mode === "look" ? lookFormVal : addFormVal;


    const action = mode === "edit" ? <>
        <Button
            className="btn-item"
            shape="round"
            disabled={(controlled || editFormVal.status !== DictCodeEnmu.PRO_CREATE)}
            onClick={() => setSettleVisible(true)}
        >确认结算</Button>
        <Button
            className="btn-item"
            shape="round"
            disabled={controlled || editFormVal.status !== DictCodeEnmu.PRO_SETTLE}
            onClick={() => {
                if (!verifyWhOrShelf()) return false;
                setWsConfirmVisible(true)
            }}
        >确认出库</Button>
    </> : mode === "look" ? <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setSettleVisible(true)}
        >结算查看</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setWsConfirmVisible(true)}
        >入库查看</Button>
    </> : false;

    const orderStatus = [
        {
            label: "采购退货单",
            value: formVal.returnCode ?? "暂无",
            color: "blue",
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(formVal.status) ?? "暂无",
            color: "green",
            status: true
        }
    ]
    return (
        <YhBox title={orderStatus.map((item, index) => <Description key={index} {...item} />)}
            style={{ padding: "0 20px", marginBottom: "10px" }}
            action={action}
        />
    )
}